import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import store from './store'
import Button from './components/Button'
import Version from './components/Version'
import './assets/scss/index.scss'
import './mixins'
import './plugins'
import './aws'

Vue.component('w-button', Button)
Vue.component('w-version', Version)

Vue.config.productionTip = false

new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')
